import { render, staticRenderFns } from "./EditParceiroModal.vue?vue&type=template&id=5bdfd176&scoped=true"
import script from "./EditParceiroModal.vue?vue&type=script&lang=js"
export * from "./EditParceiroModal.vue?vue&type=script&lang=js"
import style0 from "./EditParceiroModal.vue?vue&type=style&index=0&id=5bdfd176&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdfd176",
  null
  
)

export default component.exports